import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "./redux/actions/categoryActions";
import { fetchAllGames } from "./redux/actions/gameActions";
import HomePage from "./pages/HomePage";
import GameDetailPage from "./pages/GameDetailPage";
import scraperService from './data/scraperService';

const App = () => {
  const dispatch = useDispatch();
  const { categoriesLoaded } = useSelector(state => state.categories);
  const { gamesLoaded } = useSelector(state => state.games);

  // 在应用启动时初始化数据抓取
  useEffect(() => {
    const initializeApp = async () => {
      try {
        // // 启动自动抓取（每24小时）
        // scraperService.startAutoScraping(24);
        
        // 只在需要时获取数据
        if (!categoriesLoaded) {
          await dispatch(fetchCategories());
        }
        if (!gamesLoaded) {
          await dispatch(fetchAllGames());
        }
      } catch (error) {
        console.error('Error initializing app:', error);
      }
    };

    initializeApp();

    // 清理函数：组件卸载时停止自动抓取
    return () => {
      scraperService.stopAutoScraping();
    };
  }, [dispatch, categoriesLoaded, gamesLoaded]);

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/game/:id" element={<GameDetailPage />} />
    </Routes>
  );
};

export default App;
